var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTiktok(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.529,
    height: 23.53,
    viewBox: "0 0 23.529 23.53",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_59936",
    "data-name": "Group 59936",
    transform: "translate(-250.089)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_2",
    "data-name": "Subtraction 2",
    d: "M11.765,23.53A11.765,11.765,0,0,1,3.446,3.446,11.765,11.765,0,0,1,20.083,20.085,11.685,11.685,0,0,1,11.765,23.53Zm-1.583-13.4a4.067,4.067,0,0,0-2.625.988,4.017,4.017,0,0,0-1.385,2.663c-.013.284-.005.564,0,.8a4.052,4.052,0,0,0,1.961,3.068,3.941,3.941,0,0,0,1.994.559c.057,0,.125,0,.2-.005A4,4,0,0,0,13.5,16.481a4.117,4.117,0,0,0,.724-2.116c.01-.972.009-1.961.009-2.918,0-.572,0-1.183,0-1.781a6.794,6.794,0,0,0,.87.5,5.7,5.7,0,0,0,2.256.521V8.522a3.846,3.846,0,0,1-2.277-.962,3.318,3.318,0,0,1-.94-2.24c-.276,0-.556,0-.828,0h0c-.415,0-.843,0-1.267.008-.011,1.4-.01,2.816-.009,4.068v.3c0,.694,0,1.412,0,2.117,0,.25,0,.5,0,.747,0,.7,0,1.418-.038,2.131a1.164,1.164,0,0,1-.2.543l-.015.026a1.805,1.805,0,0,1-1.487.865c-.044,0-.09.006-.135.006A1.841,1.841,0,0,1,8.41,14.585c0-.034,0-.067,0-.1V14.45a1.74,1.74,0,0,1,.079-.73,1.851,1.851,0,0,1,.731-.94,1.748,1.748,0,0,1,1-.3,2.02,2.02,0,0,1,.62.1c0-.353.007-.723.012-1.02.008-.423.016-.9.009-1.365A3.659,3.659,0,0,0,10.182,10.134Z",
    transform: "translate(250.089)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktok);
export default __webpack_public_path__ + "static/media/tiktok.230cd57cc9d25e4f9b65dded17610561.svg";
export { ForwardRef as ReactComponent };